export function reorderByIds<T extends { id?: number }>(rows: T[], ids: number[]): T[] {
  const byId = new Map(rows.map(row => [row.id, row]));
  if (ids.length !== rows.length || new Set(ids).size !== ids.length || ids.some(id => !byId.has(id))) {
    throw new Error("لیست ترتیب معتبر نیست");
  }
  return ids.map(id => byId.get(id)!);
}

export function moveItem<T>(rows: T[], index: number, offset: number): T[] {
  const target = index + offset;
  if (index < 0 || index >= rows.length || target < 0 || target >= rows.length) return rows;
  const result = [...rows];
  const [item] = result.splice(index, 1);
  result.splice(target, 0, item);
  return result;
}
